import { Chart } from 'devextreme-react';
import { ArgumentAxis, Label, Legend, Series } from 'devextreme-react/chart';
import LoadIndicator from 'devextreme-react/load-indicator';
import { useEffect, useState } from 'react';
import reportService from '@/projects/platform/services/report-service';

export default function SalesAmountTrend(props: any) {
    var params: string;
    const { retailerId, startDate, endDate } = props;
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);

    function filter() {
        params = '';
        for (const key of Object.keys(props)) {
            if (props[key]) {
                params += `${key}=${props[key]}&`;
            }
        }
        params = params.slice(0, -1);
    }

    useEffect(() => {
        setLoading(true);
        filter();
        reportService.getSalesAmountTrend(params)
            .then((response) => {
                setDataSource(response.data.searchResult);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                throw new Error('Data Loading Error');
            });
    }, [retailerId, startDate, endDate]);

    return (
        <>
            <LoadIndicator visible={loading} />
            <Chart
                id="chart"
                title={'Sales Amount Trend'}
                dataSource={dataSource}>
                <Series argumentField="month" />
                <ArgumentAxis>
                    <Label
                        wordWrap="none"
                    />
                </ArgumentAxis>
                <Legend visible={false} />
            </Chart>
        </>
    );
}
